// Create types
export const FACTOREDINVOICE_CREATE_ERROR = 'FACTOREDINVOICE_CREATE_ERROR';
export const FACTOREDINVOICE_CREATE_LOADING = 'FACTOREDINVOICE_CREATE_LOADING';
export const FACTOREDINVOICE_CREATE_SUCCESS = 'FACTOREDINVOICE_CREATE_SUCCESS';
export const FACTOREDINVOICE_CREATE_VIOLATIONS = 'FACTOREDINVOICE_CREATE_VIOLATIONS';
export const FACTOREDINVOICE_CREATE_RESET = 'FACTOREDINVOICE_CREATE_RESET';

// Show types
export const FACTOREDINVOICE_SHOW_ERROR = 'FACTOREDINVOICE_SHOW_ERROR';
export const FACTOREDINVOICE_SHOW_LOADING = 'FACTOREDINVOICE_SHOW_LOADING';
export const FACTOREDINVOICE_SHOW_RETRIEVED_SUCCESS = 'FACTOREDINVOICE_SHOW_RETRIEVED_SUCCESS';
export const FACTOREDINVOICE_SHOW_RESET = 'FACTOREDINVOICE_SHOW_RESET';

// Update types
export const FACTOREDINVOICE_UPDATE_RESET = 'FACTOREDINVOICE_UPDATE_RESET';
export const FACTOREDINVOICE_UPDATE_UPDATE_ERROR = 'FACTOREDINVOICE_UPDATE_UPDATE_ERROR';
export const FACTOREDINVOICE_UPDATE_UPDATE_LOADING = 'FACTOREDINVOICE_UPDATE_UPDATE_LOADING';
export const FACTOREDINVOICE_UPDATE_UPDATE_SUCCESS = 'FACTOREDINVOICE_UPDATE_UPDATE_SUCCESS';
export const FACTOREDINVOICE_UPDATE_RETRIEVE_ERROR = 'FACTOREDINVOICE_UPDATE_RETRIEVE_ERROR';
export const FACTOREDINVOICE_UPDATE_RETRIEVE_LOADING = 'FACTOREDINVOICE_UPDATE_RETRIEVE_LOADING';
export const FACTOREDINVOICE_UPDATE_RETRIEVE_SUCCESS = 'FACTOREDINVOICE_UPDATE_RETRIEVE_SUCCESS';
export const FACTOREDINVOICE_UPDATE_UPDATE_VIOLATIONS = 'FACTOREDINVOICE_UPDATE_UPDATE_VIOLATIONS';

// Delete types
export const FACTOREDINVOICE_DELETE_ERROR = 'FACTOREDINVOICE_DELETE_ERROR';
export const FACTOREDINVOICE_DELETE_LOADING = 'FACTOREDINVOICE_DELETE_LOADING';
export const FACTOREDINVOICE_DELETE_SUCCESS = 'FACTOREDINVOICE_DELETE_SUCCESS';
export const FACTOREDINVOICE_DELETE_RESET = 'FACTOREDINVOICE_DELETE_RESET';

// List types
export const FACTOREDINVOICE_LIST_ERROR = 'FACTOREDINVOICE_LIST_ERROR';
export const FACTOREDINVOICE_LIST_LOADING = 'FACTOREDINVOICE_LIST_LOADING';
export const FACTOREDINVOICE_LIST_RESET = 'FACTOREDINVOICE_LIST_RESET';
export const FACTOREDINVOICE_LIST_PAGINATION = 'FACTOREDINVOICE_LIST_PAGINATION';
export const FACTOREDINVOICE_LIST_SUCCESS = 'FACTOREDINVOICE_LIST_SUCCESS';
export const FACTOREDINVOICE_LIST_ORDER = 'FACTOREDINVOICE_LIST_ORDER';
export const FACTOREDINVOICE_LIST_PAGE = 'FACTOREDINVOICE_LIST_PAGE';

// deductions List types
export const FACTOREDINVOICE_DEDUCTIONS_LIST_ERROR = 'FACTOREDINVOICE_DEDUCTIONS_LIST_ERROR';
export const FACTOREDINVOICE_DEDUCTIONS_LIST_LOADING = 'FACTOREDINVOICE_DEDUCTIONS_LIST_LOADING';
export const FACTOREDINVOICE_DEDUCTIONS_LIST_SUCCESS = 'FACTOREDINVOICE_DEDUCTIONS_LIST_SUCCESS';

// deductions List types
export const FACTOREDINVOICE_PAYMENTS_LIST_ERROR = 'FACTOREDINVOICE_PAYMENTS_LIST_ERROR';
export const FACTOREDINVOICE_PAYMENTS_LIST_LOADING = 'FACTOREDINVOICE_PAYMENTS_LIST_LOADING';
export const FACTOREDINVOICE_PAYMENTS_LIST_SUCCESS = 'FACTOREDINVOICE_PAYMENTS_LIST_SUCCESS';




// WEBPACK FOOTER //
// ./src/store/modules/factoredinvoice/mutation-types.js